import React from "react";
import { Routes, Route } from "react-router-dom";
import FileRedirect from './RfcLibrary/FileRedirect';

function Body(props) {
  const routesArray = props?.MainRoutes
  return (
    <Routes>
      {routesArray.map((route) => {
        return route.component ? (
          <Route
            path={route?.path}
            element={route?.component}
            key={route?.key}
          />
        ) : (
          <></>
        );
      })}
      {/* Catch-all for file path URLs */}
      {/* <Route path="/:filePath/*" element={require('./RfcLibrary/FileRedirect').default()} /> */}
      <Route
        path="/:filePath/*"
        element={React.createElement(require('./RfcLibrary/FileRedirect').default)}
      />

    </Routes>
  );
}

export default Body;
